import {ChannelkartNetworkPost } from "./networkService";


export async function sendSlackAlert(
    channel: string,
    subject: string,
    description: string,
    body: string
  )  {
    try {
      if (![channel, subject, description, body].every(v => typeof v === 'string')) {
        return;
      }
  
      await ChannelkartNetworkPost(`/v1/alerts/slack`, {
        channel,
        subject,
        description,
        body
      });
    
    } catch (error) {

    }
  }

export enum SlackChannel {
    DMS_PRIMARY_UI_NOTIFICATION = "DMS_PRIMARY_UI_NOTIFICATION",
    DMS_SECONDARY_UI_NOTIFICATION = "DMS_SECONDARY_UI_NOTIFICATION" 
}